import Modal from "react-bootstrap/Modal";
import {useState} from "react";
import axiApi from "ApiCaller";
import IslandModel from "./IslandModel";
import {addOrUpdateList} from "core/utils/arrays";


const ModalCreateIsland = ({showForm, setShowForm, setItemsShow, items}) => {

    const [formData, setFormData] = useState({...IslandModel})

    const handleChange = (event) => {
        const {name, value} = event.target;
        formData[name] = value;
        setFormData(formData);
    }

    const handleClose = () => {
        setShowForm(false);
    }

    const onSummit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        axiApi.post(`/api/distribution/island/`, formData).then((resp) => {
            if (resp.status === 200) {
                if (formData.id) {
                    items.current.all = addOrUpdateList(items.current.all, resp.data.item);
                    items.current.showed = addOrUpdateList(items.current.showed, resp.data.item);
                } else {
                    items.current.all.push(resp.data.item);
                    items.current.showed.push(resp.data.item);
                }

                setItemsShow([...items.current.showed])
            }
        }).catch((error) => {
            console.error('Error al enviar la solicitud:', error);
        });
        setShowForm(false);
    }

    return (
        <>
            <Modal show={showForm} onHide={handleClose} animation={true}>
                <Modal.Header closeButton>
                    <Modal.Title>Añadir Zonas</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="ms-auto" onSubmit={onSummit}>
                        <div className="col-12 mt-4 mb-4">
                            <input type="text" className="form-control" id="name" name="name"
                                   defaultValue={formData.name} placeholder="Name" onChange={handleChange}
                                   required/>
                        </div>
                        <div className="col-12  mb-4">
                            <textarea className="form-control" id="description" name="description"
                                      defaultValue={formData.description} placeholder="Description"
                                      onChange={handleChange}/>
                        </div>

                        <div className="mt-5 text-end mb-5">
                            <div className="mt-5 d-flex justify-content-end align-right">
                                <button type="submit" className="btn btn-primary">Crear</button>
                                <button type="button" className="btn btn-danger ms-4"
                                        onClick={handleClose}>Cancel
                                </button>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalCreateIsland